import AbstractAnalyticsInjector from '@/analytics/AbstractAnalyticsInjector'

export default class FacebookPixel extends AbstractAnalyticsInjector {
  load(id, config, head) {
    return new Promise((resolve, reject) => {
      const fbp = window.fbq = function() {
        fbp.callMethod ? fbp.callMethod.apply(fbp, arguments) : fbp.queue.push(arguments)
      }

      if (!window._fbq) {
        window._fbq = fbp
      }

      fbp.push = fbp
      fbp.loaded = true
      fbp.version = '2.0'
      fbp.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      script.onload = () => resolve()
      script.onerror = err => reject(err)

      head.appendChild(script)
    })
  }

  init(config) {
    if (typeof window.fbq !== 'function') {
      return false
    }

    window.fbq('init', this.accountId)
    window.fbq('track', 'PageView')

    return true
  }
}
